// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__23VCd","colMin":"styles_colMin__2nB6H","colCheckbox":"styles_colCheckbox__2ZSVH"};